export default __webpack_public_path__ + "f5b421eeb63d2b058098cdd8e412dd87.png";